<style lang="less">
  @import "./tabbar.less";
</style>
<template>
  <div class="zf_tabbar_content" ref="scrollBody" :style="{left: tagBodyLeft + 'px'}">
    <div
      :class="
        isActive === '/main' ? 'zf_tabbar_item isactive' : 'zf_tabbar_item'
      "
      @click="toRouter('/main')"
    >
      <span :title="$t('home.title')">{{$t('home.title')}}</span>
    </div>
    <div
      :class="
        isActive === item.path ? 'zf_tabbar_item isactive' : 'zf_tabbar_item'
      "
      v-for="(item, i) in tabList"
      :key="i"
      @click="toRouter(item.path)"
    >
      <span :title="item.title">{{ item.title }}</span>
      <span
        class="el-icon-close zf_tabbar_item_close"
        @click.stop="closeTab(item.path)"
      ></span>
    </div>
  </div>
</template>
<script>
export default {
  name: "mTabbar",
  props:{
  	tagBodyLeft:{
  		type:Number,
  		default:0
  	}
  },
  data() {
    return {
      tabList: [],
      isActive: "/main",
      oldIsActive: "",
      domObj: null
    };
  },
  computed:{
  },
  created() {
  	console.log(this.$route)
    if (this.$route.name != "Main" && this.$route.name != "Home" ) {
    	if(typeof(this.$route.meta.isShow) =='undefined' ){
	      this.tabList.push({
	        name: this.$route.name,
	        path: this.$route.path,
	        title: this.$route.meta.title || this.$route.params.title,
	      });
    	}
    }
    this.isActive = this.$route.path;
  },
  computed: {},
  mounted() {
  },
  methods: {
    // 点击跳转
    toRouter(path) {
      this.$router.push(path);
    },
    // 点击关闭
    closeTab(path) {
      if (this.tabList.length === 1) {
        this.$router.push("/main");
        this.tabList = [];
        return;
      }

      this.tabList = this.tabList.filter((item) => item.path !== path);
      if (path !== this.isActive) {
        this.oldIsActive = this.tabList[0].path;
        return;
      }
      this.isActive =
        this.oldIsActive === path ? this.tabList[0].path : this.oldIsActive;
      this.$router.push(this.isActive);
    },
  },
  watch: {
    $route(value) {
      console.log(value)
      if (value.name === "Main" || value.name=='Home') {
        let oldIsActive = this.isActive;
        this.oldIsActive = oldIsActive;
        this.isActive = '/main';
        return;
      }
      let oldIsActive = this.isActive;
      this.oldIsActive = oldIsActive;
      this.isActive = value.path;
      let routeItem =null;
      $.each(this.tabList,(i,item)=>{
      	if(item.path === value.path){
      		routeItem=item;
      	}
      })
      console.log(routeItem);
      if (!routeItem && typeof(value.meta.isShow) =='undefined' ) {
        this.tabList.push({
          name: this.$route.name,
          path: this.$route.path,
          title: this.$route.meta.title || this.$route.params.title,
        });
      }
      
    },
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Tabbar/index.vue